import { TableConfig } from '@shared/interfaces/table/table-config';
import { dashboardColumns } from '@shared/columns/dashboard.columns';

export const serviceRequestTableConfig: TableConfig<any> = {
  activeColumns: ['meteringPointIdentification', 'address', 'meteringPointType', 'physicalStatus', 'partyName', 'settlementMethod', 'created', 'occurrence', 'userResponse', 'actionResponse', 'serviceRequestCode', 'isCancelledBySupplier', 'reasonText'],
  columns: dashboardColumns,
  columnSelection: false,
  fetchOnLoad: true,
  oData: true,
  pageSize: 100,
  pageSizeSelection: true,
  reorder: true,
  saveChanges: true,
  selectable: true,
  selectableType: 'single',
}
